var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _rect, _rect2, _rect3, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeprecation = function SvgDeprecation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.833 11.208v3.632l24.906 5.189h3.632l24.387-4.67v-4.151L53.2 9.651H3.39l-1.557 1.557Z",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.415,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.833 44.934H4.129c-1.26 0-2.296-.98-2.296-2.209V11.861c0-1.213 1.018-2.21 2.296-2.21h48.333c1.26 0 2.295.98 2.295 2.21V22",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.124 44.934H7.02v4.485h7.103v-4.485Z",
    fill: "#E5E5E5",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m54.758 15.877-25.944 4.67-26.981-5.189M23.715 5.5h10.201c1.188 0 2.164.68 2.164 1.508v2.643H21.552V7.008c0-.828.976-1.508 2.163-1.508Z",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.851 20.029a2.076 2.076 0 0 1-4.15 0 2.076 2.076 0 0 1 4.15 0Z",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.048,
    cy: 42.34,
    r: 18.16,
    fill: "#EAFFE6",
    stroke: "#000",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.317 34.437h17.91c.328 0 .594.265.594.593v2.632a.594.594 0 0 1-.594.594h-17.91a.594.594 0 0 1-.593-.594V35.03c0-.328.266-.593.593-.593Z",
    fill: "#58B847"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.317 34.437h17.91c.328 0 .594.265.594.593v15.914a.594.594 0 0 1-.594.594h-17.91a.594.594 0 0 1-.593-.594V35.03c0-.328.266-.593.593-.593ZM39.724 38.256H58.82",
    stroke: "#000",
    strokeWidth: 0.663,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.939,
    y: 33.15,
    width: 1.617,
    height: 2.572,
    rx: 0.809,
    fill: "#58B847",
    stroke: "#000",
    strokeWidth: 0.663
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.67,
    y: 33.15,
    width: 1.617,
    height: 2.572,
    rx: 0.809,
    fill: "#58B847",
    stroke: "#000",
    strokeWidth: 0.663
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.213,
    y: 33.15,
    width: 1.617,
    height: 2.572,
    rx: 0.809,
    fill: "#58B847",
    stroke: "#000",
    strokeWidth: 0.663
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.21 41.475v-.045l-.244.036a.715.715 0 0 0-.413.214 164.155 164.155 0 0 0-2.621 2.702c-.7.73-1.395 1.459-2.112 2.186l-2.003-1.598a.713.713 0 0 0-1.004.11.713.713 0 0 0 .112 1.004l2.507 2.006h.001c.285.227.696.2.951-.058.899-.9 1.752-1.795 2.602-2.685l.02-.022c.843-.883 1.682-1.762 2.558-2.64a.712.712 0 0 0-.354-1.21Z",
    fill: "#58B847",
    stroke: "#000",
    strokeWidth: 0.424
  })));
};
export default SvgDeprecation;